import zdjecie from "../../img/god.png";
import { ProjektContent } from "../News";
export default function Grafika() {
  return (
    <ProjektContent>
      <img alt="Błąd" src={zdjecie} />
    </ProjektContent>
  );
}
